import { Workspace } from "@/components/sim/Workspace";
import "./simulator.css";

export default function Simulator() {
  return (
    <div className="simulator-scope">
      <Workspace />
    </div>
  );
}